import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.RecipeFilters;

// initial state
// object name must match specification name
//specification, label, defaultValue, collapsible, expandDefault, groupType, subgroup, className
const urlParams = new URLSearchParams(window.location.search);
const searchParam = urlParams.get('Search');
const menuParam = urlParams.get('MenuTypes');
const mealParam = urlParams.get('MealTypes');

const filters = {
    MenuTypes: new FormControl.FilterGroup('MenuTypes', 'Menu Type', menuParam, false, true, 'select', '', '', 'False', '-Select a menu type-'),
    MealTypes: new FormControl.FilterGroup('MealTypes', 'Meal Type', mealParam, false, true, 'select', '', '', 'False', '-Select a meal type-'),
    search: new FormControl.FilterGroup(
        'Search', 'Search', searchParam, false, true, 'textbox',
        new FormControl.Textbox('Search recipes', 'Search', true), 'filter-search'
    ),
    //MealType: new FormControl.FilterGroup('MealType', 'Filter by Type', null, false, true, 'checkbox', undefined, 'filter-flex filter-buttons-equal'),
};

FormControl.assignFilters(filterObj, filters);

if (filters.MenuTypes.subgroup) {
    filters.MenuTypes.subgroup.unshift(new FormControl.DropdownSelectOption('', 'All Menu Types'));
}

if (filters.MealTypes.subgroup) {
    filters.MealTypes.subgroup.unshift(new FormControl.DropdownSelectOption('', 'All Meal Types'));
}

export { filters as default };
